import ThemeTableSimple2 from 'assets/components/table/themes/Theme.Table.Simple.2';
import { getLocales } from 'assets/locales/Locale';
import { defaultDateFormat } from 'assets/utils/data/Date';
import { formatPercentage, roundToStep } from 'assets/utils/data/Number';
import dayjs from 'dayjs';
import RefundTermStartDateSource from 'models/enums/RefundTermStartDateSource';

export const getTermStartEffectiveDate = (
  refundConfigTemplate: Utils.FormData<Model.IRefundConfigTemplate>,
  contract: Model.IContract
) =>
  refundConfigTemplate?.termStartDateSource === RefundTermStartDateSource.ContractCreatedAtLocal
    ? contract?.createdAtLocal
    : contract?.effectiveDate;

const RefundInfoTable = ({
  refundPriceInfo,
  contract,
  contractCancellation,
}: {
  refundPriceInfo: Api.Sales.ContractRefund.RefundPricingInfo.RefundPriceInfo;
  contract: Model.IContract;
  contractCancellation: Model.IContractCancellation;
}) => {
  const { lang } = getLocales();

  const termStartEffectiveDate = getTermStartEffectiveDate(refundPriceInfo?.refundConfigTemplate, contract);

  return (
    <table className={ThemeTableSimple2}>
      <thead>
        <tr>
          <th>{lang.term}</th>
          <th></th>
          <th>{lang.kms}</th>
          <th></th>
          <th>{lang.profitRetention}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{lang.effectiveDate}</td>
          <td>{dayjs(termStartEffectiveDate).format(defaultDateFormat)}</td>

          <td style={{ fontWeight: 600 }}>{lang.startingOdometerReading}</td>
          <td>{contract?.vehicle?.posOdometerReading}</td>

          <td style={{ fontWeight: 600 }}>{lang.dealerProfitAmt}</td>
          <td>{roundToStep(refundPriceInfo.dealerProfitValueAtSale, 0.01)}</td>
        </tr>
        <tr>
          <td>{lang.cancellationDate}</td>
          <td>{dayjs(contractCancellation?.cancellationDateLocal).format(defaultDateFormat)}</td>

          <td style={{ fontWeight: 600 }}>{lang.currentOdometerReading}</td>
          <td>{contractCancellation?.odometerReading}</td>

          <td style={{ fontWeight: 600 }}>{lang.dealerProtectProfitExpirationDays}</td>
          <td>{refundPriceInfo?.refundConfigTemplate?.dealerProtectProfitExpirationDays}</td>
        </tr>
        <tr>
          <td>{lang.expiryDate}</td>
          <td>{dayjs(contract?.expiryDate).format(defaultDateFormat)}</td>

          <td style={{ fontWeight: 600 }}>{lang.maxCoverageKMUsedInDP}</td>
          <td>{contract?.maxCoverageKm}</td>

          <td style={{ fontWeight: 600 }}>{lang.dealerProtectedProfitExpirationDay}</td>
          <td>{0}</td>
        </tr>
        <tr>
          <td>{lang.termInDays}</td>
          <td>{refundPriceInfo.termInDays}</td>

          <td style={{ fontWeight: 600 }}>{lang.termInKM}</td>
          <td>{refundPriceInfo.termInKms}</td>

          <td style={{ fontWeight: 600 }}>{lang.protectedDealerProfitAmt}</td>
          <td>{refundPriceInfo.refundConfigTemplate?.dealerProtectProfitAmount}</td>
        </tr>
        <tr>
          <td>{lang.termDaysConsumed}</td>
          <td>{refundPriceInfo.usedTermInDays}</td>

          <td style={{ fontWeight: 600 }}>{lang.kmsUsedConsumed}</td>
          <td>{refundPriceInfo.usedOdometerReading}</td>

          <td style={{ fontWeight: 600 }}>{lang.unprotectedDealerProfitAmt}</td>
          <td>{refundPriceInfo.unprotectedDealerProfitAmt}</td>
        </tr>
        <tr>
          <td>{lang.termDaysRemaining}</td>
          <td>{refundPriceInfo.remainingTermInDays}</td>

          <td style={{ fontWeight: 600 }}>{lang.kmsRemaining}</td>
          <td>{refundPriceInfo.remainingOdometerReading}</td>

          <td style={{ fontWeight: 600 }}>{lang.retainFactor}</td>
          <td>{refundPriceInfo.retainFactor}</td>
        </tr>
        <tr>
          <td>{lang.percentOfTermConsumed}</td>
          <td>{formatPercentage(refundPriceInfo.usedTermInDaysPercentage)}</td>

          <td style={{ fontWeight: 600 }}>{lang.percentOfKMConsumed}</td>
          <td>{formatPercentage(refundPriceInfo.usedOdometerReadingPercentage)}</td>

          <td style={{ fontWeight: 600 }}>{lang.refundFactor}</td>
          <td>{refundPriceInfo.refundFactor}</td>
        </tr>
        <tr>
          <td>{lang.percentOfTermRemaining}</td>
          <td>{formatPercentage(refundPriceInfo.remainingTermInDaysPercentage)}</td>

          <td style={{ fontWeight: 600 }}>{lang.percentOfKMRemaining}</td>
          <td>{formatPercentage(refundPriceInfo.remainingOdometerReadingPercentage)}</td>

          <td style={{ fontWeight: 600 }}>{lang.refundFactorAfterMinimumRetained}</td>
          <td>{0}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default RefundInfoTable;
